
export default class DeviceOrientationChecker {
    constructor(isLandscape, rootElement, onValidOrientation, onInvalidOrientation){     	
        this.isValidOrientation = false;

        this.isLandscape = isLandscape;
        
        this.rotateElement = document.createElement('div');
        
        this.rotateElement.id = 'rotate-screen';
        this.rotateElement.className = 'hidden';
        this.rotateElement.style.position = "absolute";
        this.rotateElement.style.width = "100%";
        this.rotateElement.style.height = "100%";
        this.rotateElement.style.top = "0";
        this.rotateElement.style.left = "0";
        this.rotateElement.style.zIndex = "2147483647";
        this.rotateElement.style.backgroundColor = "#ff498b";
        this.rotateElement.style.backgroundImage = "url('media/images/rotate.png')";
        this.rotateElement.style.backgroundRepeat = "no-repeat";
        this.rotateElement.style.backgroundSize = "contain";
        this.rotateElement.style.backgroundPosition = "center";
        
        this.rotateElement.style.textIndent = '-100%';
        this.rotateElement.innerHTML = 'please rotate your device';

        rootElement.appendChild(this.rotateElement);

        this.onValidOrientation = onValidOrientation;
        this.onInvalidOrientation = onInvalidOrientation;
        
        window.addEventListener("resize", this.OnResize.bind(this));
        window.addEventListener("orientationchange", this.CheckOrientation.bind(this));
        
        this.CheckOrientation();
    }

    CheckOrientation() {
        let wasValidOrientation = this.isValidOrientation;
        this.isValidOrientation = this.isLandscape ? window.innerWidth > window.innerHeight : window.innerWidth < window.innerHeight;
    
        this.rotateElement.style.display = this.isValidOrientation ? 'none' : 'block';

        if(this.isValidOrientation){
            //Fire function
            if(this.onValidOrientation){
                this.onValidOrientation.call();
            }
        }
        else{
            if(this.onInvalidOrientation){
                this.onInvalidOrientation.call();
            }
        }
        
        if(wasValidOrientation != this.isValidOrientation){
            // if(this.isValidOrientation){
            //     GameManager.Instance.Resume();
            // }
            // else{
            //     GameManager.Instance.Pause();
            // }
        }
    }
    
    OnResize() {
        setTimeout(function(){
            this.Resize();
        }.bind(this),50);
        this.Resize();
    }
    
    Resize() {
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        this.rotateElement.style.width = windowWidth + "px";
        this.rotateElement.style.height = windowHeight + "px";
    
        this.CheckOrientation();
    }
    
}